<script lang="ts">
  import { NodeViewWrapper } from "svelte-tiptap";
  import InlineMentionBlock, {
    type InlineMention,
    type MentionType,
  } from "../../Mention/InlineMentionBlock.svelte";
  import type { NodeViewProps } from "@tiptap/core";
  import { communitySlug } from "app/stores/community";
  import type { GenericSpace } from "app/models/spaces";
  import type { WritableDocument } from "app/models/documents";
  import { spaces } from "app/stores/community";
  import type { ForumSpace } from "@outverse-video/outverse-api-client-lib";
  import { getStores } from "$stores";
  import { isDarkTheme } from "app/stores/userPreferences";

  const { docs } = getStores();
  export let node: NodeViewProps["node"];
  export let selected: NodeViewProps["selected"];
  export let isEditable: boolean;
  $$restProps; // prevent svelte unused props warning

  const { space }: { space: GenericSpace } = node.attrs as any;

  const isDocument = (item: GenericSpace | Document | undefined): item is Document => {
    // some mentions are missing a space - so check they are defined first
    return !!item && typeof item !== "string" && "folder" in item && !!item.folder;
  };

  let doc: WritableDocument;

  let mentionType: MentionType = isDocument(space) ? "docs" : "spaces";
  let icon: string | undefined;

  $: $isDarkTheme, getIcons(space);

  const selectIconVariant = (
    icon: string | undefined | null,
    iconDark: string | undefined | null
  ): string | undefined => {
    if ($isDarkTheme && (iconDark || icon)) {
      return iconDark ? iconDark : (icon ?? undefined);
    }

    if (!$isDarkTheme && icon) {
      return icon;
    }
  };

  const getIcons = (item: InlineMention): string | undefined => {
    if (mentionType === "docs") {
      doc = docs.getDocumentSynchronously(item.uuid);

      // Later work can be done to handle gracefully handle deleted content
      if (!doc) return undefined;

      icon = selectIconVariant($doc.icon, $doc.iconDark);
    } else if (mentionType === "spaces") {
      let space = $spaces.spaces[item.uuid] as ForumSpace;

      // Later work can be done to handle gracefully handle deleted content
      if (!space) return undefined;

      icon = selectIconVariant(space?.icon, space?.iconDark);
    }
  };

  const getItemTitle = (item: InlineMention) => {
    let title = item.title;

    if (mentionType === "docs") {
      doc = docs.getDocumentSynchronously(item.uuid);

      if (doc) {
        title = $doc.title;
      }
    } else if (mentionType === "spaces") {
      let space = $spaces.spaces[item.uuid] as ForumSpace;

      if (space) {
        title = space.title;
      }
    }
    return title;
  };
</script>

<NodeViewWrapper class="inline-flex align-top">
  <InlineMentionBlock
    {mentionType}
    item={{ ...space, title: getItemTitle(space) }}
    {icon}
    communitySlug={$communitySlug}
    editable={isEditable || false}
    {selected}
  />
</NodeViewWrapper>
